import { useNavigate } from "react-router-dom";
import CryptoJs from "crypto-js";
import Main from "../../components/main";
import styles from "./index.module.scss";
import { useState, useRef, useEffect } from "react";
import api from "../../services/api";
import toast from "../../components/toast";
import { http } from "../../services/fetcher";
import { observer, inject } from "mobx-react";
import { classNames } from "../../tool";
import { setLocalStore } from "../../tool/localStore";
import md5 from "js-md5";
import YidunCaptcha from "./YidunCaptcha";

function Login({ store }) {
  const { dicInfo } = store;
  const [inputIndex, setInputIndex] = useState(0);
  const [accountNo, setAccountNo] = useState("");
  const [password, setPassword] = useState("");
  const [accountPwdStatus, setAccountPwdStatus] = useState(true);
  const navigate = useNavigate();
  const compositionRef = useRef(false);
  useEffect(() => {
    store.getDicInfo();
  }, []);

  const onChange = (e) => {
    if (e.type === "compositionend") {
      compositionRef.current = false;
      if (!compositionRef.current) {
        const value = e.target.value.replace(/\s/g, "");
        if (inputIndex === 1) {
          setPassword(value);
        } else {
          setAccountNo(value);
        }
      }
    } else {
      compositionRef.current = true;
    }
  };

  const handleComposition = (e) => {
    if (e.type === "compositionend") {
      compositionRef.current = false;
      if (!compositionRef.current) {
        onChange(e);
      }
    } else {
      compositionRef.current = true;
    }
  };

  const handleLoginClick = async (validate) => {
    if (password && accountNo) {
      const params = {
        type: 0,
      };
      params.accountNo = accountNo;
      params.password = md5(password);

      if (validate) {
        params.validateCode = validate;
      }
      const res = await http(api.login, params);
      if (res.code === "C2") {
        localStorage.setItem("login", "login");
        localStorage.setItem(
          "fff",
          CryptoJs.AES.encrypt(password, "account").toString()
        );
        setLocalStore("acc", JSON.stringify(res.result));
        store.setUserInfo(res.result);
        navigate("/");
      } else {
        toast(res.message);
      }
    } else {
      toast("请正确输入账号或密码");
    }
  };

  const renderLoginBtn = (isNeedClick) => {
    return (
      <div
        className={classNames(
          styles.btn,
          accountNo && password ? "" : styles.disabled
        )}
        onClick={() => {
          if (isNeedClick) {
            handleLoginClick("");
          }
        }}
      >
        登录
      </div>
    );
  };
  return (
    <Main className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>用户登录</div>
        <div className={styles.item}>
          <div className={styles.input}>
            <img
              className={styles.icon}
              src={require("../../assets/imgs/username.png")}
            />
            <input
              type={"text"}
              placeholder="请输入用户名"
              value={accountNo}
              maxLength={16}
              onFocus={() => setInputIndex(0)}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onChange={(e) => {
                setAccountNo(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.item}>
          <div className={styles.input}>
            <img
              className={styles.icon}
              src={require("../../assets/imgs/password.png")}
            />
            <input
              type={accountPwdStatus ? "password" : "text"}
              placeholder={`请输入密码`}
              value={password}
              maxLength={15}
              onFocus={() => setInputIndex(1)}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, "");
                setPassword(e.target.value);
              }}
            />
            <img
              className={styles.iconEye}
              src={require(`../../assets/imgs/eye${
                accountPwdStatus ? "Close" : "Open"
              }.png`)}
              alt=""
              onClick={() => {
                setAccountPwdStatus(!accountPwdStatus);
              }}
            />
          </div>
        </div>
        {/* <div className={styles.item}>
          <div className={`${styles.input} ${styles.inputCode}`}>
            <img
              className={styles.icon}
              src={require("../../assets/imgs/verifyCode.png")}
            />
            <input
              type={"text"}
              placeholder="请输入验证码"
              value={accountNo}
              maxLength={4}
              onChange={(e) => {
                setAccountNo(e.target.value);
              }}
            />
            <div className={styles.codeImgContainer}></div>
            <img
              className={styles.refreshIcon}
              src={require("../../assets/imgs/iconRefresh.png")}
            />
          </div>
        </div> */}
        {Number(dicInfo[`wangyi.enable`]) ? (
          <YidunCaptcha
            callback={handleLoginClick}
            disabled={!accountNo || !password}
            id={"login"}
            sysSetting={store.dicInfo}
          >
            {renderLoginBtn()}
          </YidunCaptcha>
        ) : (
          renderLoginBtn(true)
        )}
      </div>
    </Main>
  );
}
export default inject("store")(observer(Login));
